import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage, t } from '../context/LanguageContext';

function NotFoundPage() {
    const { lang } = useLanguage();
    return (
        <div className="container text-center mt-5">
            <h1>{t('404 - Page Not Found', '404 - Página No Encontrada', lang)}</h1>
            <p>{t("The page you are looking for doesn't exist or has been moved.", 'La página que busca no existe o fue movida.', lang)}</p>
            <Link to="/" className="btn btn-primary mt-3">
                {t('Go to Login', 'Ir al Inicio de Sesión', lang)}
            </Link>
        </div>
    );
}

export default NotFoundPage;
